import type {
  IconDefinition,
  SizeProp,
} from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors, Text, VStack } from '@rtkwlf/fenrir-react';

type EmptyResultsContentProps = {
  title: string;
  description?: string;
  icon?: IconDefinition;
  iconSize?: SizeProp;
  linkButton?: React.ReactNode;
};

export const EmptyResultsContent: React.FC<EmptyResultsContentProps> = ({
  icon,
  iconSize,
  title,
  description,
  linkButton,
}) => (
  <>
    {icon && (
      <FontAwesomeIcon
        icon={icon}
        color={`rgb(${colors.icon.neutral.default})`}
        size={iconSize ?? '4x'}
      />
    )}
    <VStack gap="smedium" xAlign="center">
      <Text styledAs="custom" fontWeight="bold" fontSize="large">
        {title}
      </Text>
      {description && <Text styledAs="body3">{description}</Text>}
    </VStack>
    {linkButton}
  </>
);
